import { ApiRequestError } from '@croissants/contracts';
import { bindErrorSentence } from '@croissants/ui';
import { internalCatalog } from '../i18n/index';

/**
 * The console's binding of the platform's ONE error renderer.
 *
 * The order - registered key, then HTTP status, then code - lives in
 * `errorSentence` (`@croissants/i18n`); this portal supplies only its own
 * catalogue, so its wording still wins for the keys it declares. It never read
 * `error.status` at all before, which is how a bare framework 404 arrived here
 * as "Something went wrong." while the same failure read three other ways on
 * the three other portals.
 */
const describeError = bindErrorSentence(internalCatalog);

/**
 * Refusals whose sentence only the SERVER can write, because it names records
 * this screen never loaded: a guest price below what bakers keep names every
 * baker affected (#2125 decision guest-price-below-baker-price), and the Menus
 * tab shows one house at a time. Internal is English-only, so the wire's
 * English message IS the sentence; the catalogue's own copy is the fallback
 * when the message is empty.
 */
const SERVER_SENTENCE_KEYS: ReadonlySet<string> = new Set(['error.guest_price_below_bakery_price']);

export function describeApiError(
  error: unknown,
  locale: Parameters<typeof describeError>[1],
): string {
  return error instanceof ApiRequestError &&
    SERVER_SENTENCE_KEYS.has(error.messageKey) &&
    error.message !== ''
    ? error.message
    : describeError(error, locale);
}
